<script lang="ts" setup>
interface Prors {
  content?: any
}
withDefaults(defineProps<Prors>(), {
  content: '',
})
</script>

<template>
  <Copy class="cursor-pointer" :class="{ 'w-full': content }" :content="content">
    <template v-if="content" #content>
      <span class="flex-1 truncate"><slot>{{ content }}</slot></span>
    </template>
  </Copy>
</template>
